import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { Fraction } from '../../api/models';

export type TABLE_TYPE = Table<Fraction>;

export const TABLE = 'fraction';
const SCHEMA = 'fractionId, sortId';

class FractionDatabase implements DataRepository<Fraction> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<Fraction | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: Fraction, key: Key): Promise<Fraction> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: Fraction[]): Promise<Fraction[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<Fraction[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const FractionDB = new FractionDatabase(db);
